import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Qué formato tiene el material?',
  answer: 'El material es 100% digital en formato PDF de alta calidad, optimizado para ver en cualquier pantalla o para imprimir.'
}, {
  question: '¿Puedo usarlo en celular o tablet?',
  answer: '¡Sí! Puedes llevar tus mapas mentales en tu celular, tablet o computadora y estudiar donde quieras.'
}, {
  question: '¿Es útil para cualquier carrera de salud?',
  answer: 'Absolutamente. Está diseñado cubriendo la anatomía humana general, siendo ideal para Medicina, Enfermería, Kinesiología, Odontología y otras carreras afines.'
}, {
  question: '¿Cuándo recibo el material?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico con el enlace de descarga al instante.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí, cuentas con una garantía incondicional de 7 días. Si no estás satisfecho, te devolvemos tu dinero.'
}, {
  question: '¿Puedo compartirlo con compañeros?',
  answer: 'El acceso es personal e intransferible. El sistema detecta accesos inusuales para proteger los derechos de autor.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-white px-4" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-36">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-38">
              <button className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-39">
                <span className="font-bold text-gray-900" data-id="element-40">{faq.question}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-41" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-42" />}
              </button>
              {openIndex === index && <div className="p-5 bg-white text-gray-600 border-t border-gray-200" data-id="element-43">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}